import { Button } from 'antd'
import send from '@/assets/icon/AI／icon／send.png'

interface LoadingButtonProps {
  isLoading: boolean
  inputValue: string
  onClick: (val: string) => void
}

const LoadingButton: React.FC<LoadingButtonProps> = ({
  isLoading,
  inputValue,
  onClick,
}) => {
  const disabled = !inputValue.trim()

  return (
    <Button
      loading={isLoading}
      disabled={disabled}
      onClick={() => onClick(inputValue)}
      style={{
        width: 40,
        height: 40,
        backgroundColor: disabled ? '#ADC6FF' : '#3363FF',
        borderRadius: '8px',
      }}
      onMouseEnter={(e) => {
        if (!disabled && !isLoading) {
          ;(e.currentTarget as HTMLElement).style.backgroundColor = '#693CF0'
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled && !isLoading) {
          ;(e.currentTarget as HTMLElement).style.backgroundColor = '#3363FF'
        }
      }}
    >
      {!isLoading && (
        <img
          src={send}
          alt="提交"
          style={{
            width: 20,
            height: 20,
          }}
        />
      )}
    </Button>
  )
}

export default LoadingButton
